<template>
  <div class="row">
    <div class="col-lg-8">
      <h2 class="inline">Generate Report</h2>
    </div>

    <div class="col-lg-12">
      <hr />
    </div>
    <div class="col-md-12">
      <card card-body-classes="table-full-width">
        <h4 slot="header" class="card-title">List of Investigation Report</h4>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <base-input label="rows visible">
              <el-select
                class="select-info mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </base-input>
            <base-input>
              <el-input
                type="search"
                class="mb-3 search-input"
                clearable
                prefix-icon="el-icon-search"
                placeholder="Search records"
                v-model="searchQuery"
                aria-controls="datatables"
              ></el-input>
            </base-input>
          </div>
          <el-table
            :data="queriedData"
            @select="handleSelectionChange"
            :header-cell-style="{
              background: 'transparent',
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
            :cell-style="{
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
          >
            >
            <el-table-column
              v-if="false"
              :min-width="130"
              prop="InstID"
            ></el-table-column>
            <el-table-column
              :min-width="130"
              label="Case No"
              prop="ControlCaseNo"
            ></el-table-column>
            <el-table-column
              :min-width="130"
              label="Date of Investigation"
              prop="DateOfInst"
            ></el-table-column>
            <el-table-column
              :min-width="130"
              label="Officer Name"
              prop="InstName"
            ></el-table-column>
            <el-table-column
              :min-width="130"
              label="Staff ID"
              prop="InstStaffID"
            ></el-table-column>
            <el-table-column type="selection" width="55"></el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></base-pagination>
        </div>
      </card>
    </div>
    <div class="col-lg-12 text-right">
      <base-button @click="generate()" type="primary"
        >Generate Report</base-button
      >
    </div>
  </div>
</template>
<script>
import { BasePagination } from "src/components";
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import jsPDF from "jspdf";
import image from "./ReportImage";
import moment from "moment";

export default {
  components: {
    BasePagination,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },

  data() {
    return {
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["ControlCaseNo"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
    };
  },

  methods: {
    async getImageB64(imageName) {
      console.log("masyukkk");
      let imagedata = new Promise((resolve, reject) => {
        this.$http
          .get(":9994/images/" + imageName, {
            // .get("https://alpha.vectolabs.com:8002/images/" + imageName, {
            responseType: "blob",
          })
          .then((response) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(response);
          });
      });

      return imagedata;
    },
    async generate() {
      const maxHeight = 283;
      const newLine = 5;
      const newSpacing = 10;
      var doc = jsPDF("p", "mm", "a4");
      var width = doc.internal.pageSize.getWidth();
      var height = doc.internal.pageSize.getHeight();

      for (let i = 0; i < this.multipleSelection.length; i++) {
        console.log(this.multipleSelection[i]);
        this.$http
          .post(
            `:9994/api/v1/report/detail/${this.multipleSelection[i].InstID}`
          )
          .then(async (res) => {
            if (!res.error) {
              console.log(res.message);
              const investigators = res.message.investigators;
              const personInvolve = res.message.personInvolve;
              const vehicleInvolve = res.message.vehicleInvolve;
              const instDetail = res.message.instDetail;
              const images = res.message.images;
              const causeBy = res.message.causeBy;
              const instMethod = res.message.instMethod;
              const validation = res.message.validation;
              const followUp = res.message.followUp;
              const jkkpForm = res.message.jkkpForm;

              var img =
                "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";
              // "iVBORw0KGgoAAAANSUhEUgAAAFkAAAAyCAYAAAA3OHc2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABC9JREFUeNrsW01O20AUnkY5gCW2lepF93WXXuGcgHACnBO4LLwmrFmEnAD3BIQTxFmxrNlXwpW6reTeoPMyzzBx5o3t2IFQ3ieNAE/8/PzNm/c3RAgGg8Fg/L/w40COsfb3eH3tHWPQM7lL+RsMT5vx1tdgzo+990jysAdygbiZHHXWCvM/5OcT+fNS3F/lbMnNCA7XxNUTrAPuecR7meQGcF/p3nfqkxlMMpPMJDOYZCaZwSQzyUwyg0lmkplkBpPMJDPMaNa0V415B//KxP1VsRdt/BieUZ6e5H009v98/KzrXhz9/pn1pF+gzaQ2nYeEMDijO0FBrmE+1wR3JRbkR3KMt57lx+ULfJfKJy1IjSjd5bwiQ4gFyK0lXekXynEm6B74hUHnu/UzJOkfDBZ7IzbP6HYBHC9NUeZ0Qwn9M1UF7QAyRtQukuQ5qPu4pa5A9kSSXRgIBnJn2k5oi1TqOxpUrHfZA8FNEbUgWIjyQJa23scdCBZ4zxIXqUrwTQeCK4FPbYleBLbALs/yiLPBrrrDIt1WXMSs78DXREnYroVod2jaBqV8UfMM2AGJZsXTmt2Xouy/chxbZAdSVijdRoLW7Vj0vDNc/4Q+O9gmWa0a9WB46XN04IUhGEQdLQhkztek6VFZRXHKv3rr+Wd9IgsZp5K0vOJaXLRa08Kc4QIeEzInjQKw+meekzJQDpEsigAINNvRVxEyxUh60cFyT41pGhDoxxNcfIfY3qkkjJovTAQD4Jq8b4Q+3DFYs3Nklpk1zXDk51I9+xpYVm1uJLg/3FnzYGWpdc+nduDCRLBGdKG7HMMCmuDiDtvJJ7uW1ObQ8YVcwHr8spBcEIH6VhI9J+YLyihpkvdrxfvOUC7kto92vBeur4h4EFiDsnKfGXqBpF1Z/fbQNddfdEjhVEHnx1FZPHGDyLyLwZ9f97DQt8/FCKOamQDR5z0QDf9O7A3Rh3jGXE+lIodPyDYSS2Br4irEE9Eq0IWWLKyueBoPLYqeiL46bfvDAxGgVli59eU6pjXFh4OuwUT28QAjqQnhrnnhC4IygrMX9uFgqJe2BtHCksosD5loaa0psROhcrvpJLz9Vy8cuhiBfNiPU8LUVQtRfQUBtmaOwjwsBIID4HpOlPYhlt1zjDtZtWeM8+V7QoNHb+LPkOgF7vaMrB1Ur4JqL+RlnnxpIQxI/XbALuMa44dnLIW1fBdPReyl/va7h0/9HVVsVN2UK+zfGlgNtIbGtXiDQOucWAL4PhBow0YwnPklg4105e0SrY6m6htKL51enm4XI4roUYfUrUAflr4G0XJ8RavOexDZRUYqtDbx0JCOpOsPqcb8GAOcSxD6oAmljvBzgvQmL5G1LEIE5scJnvsFGNBsmcJKe4dM42EiOThHGR4WIw4hK8exEuqAIxMMBoPRHv8EGAASPm+RVcqdzwAAAABJRU5ErkJggg==";
              doc.rect(160, 0, 70, 10);
              doc.rect(60, 20, 95, 30);
              doc.rect(10, 20, 50, 30);
              doc.rect(155, 20, 50, 30);
              doc.setFontSize(14);
              doc.setFontType("bold");
              // doc.text("DHES SDN. BHD", 87, 35);
              doc.text("AFES SDN. BHD", 87, 35);

              doc.setFontType("bold");
              doc.setFontSize(12);
              doc.text("LAPORAN PENYIASATAN KEMALANGAN", 65, 41);
              doc.addImage(img, "JPEG", 25, 30, 20, 10);

              doc.setFontType("normal");
              doc.setFontSize(12);
              doc.text("NO KAWALAN KES:", 160, 35);
              doc.text(this.multipleSelection[i].ControlCaseNo, 160, 40);

              // ######################################################### BAHAGIAN A ######################################################### //
              doc.setDrawColor(0);
              doc.setFillColor(211, 211, 211);
              doc.rect(10, 50, 195, 11, "FD");
              doc.setFontType("bold");
              doc.setFontSize(10);
              doc.text("A. MAKLUMAT PEGAWAI PENYIASAT", 12, 54);

              doc.setFontType("normal");
              doc.setFontSize(10);
              doc.text("(sila gunakan lampiran jika perlu)", 12, 59);
              doc.rect(10, 61, 195, 220);

              doc.setFontType("normal");
              doc.setFontSize(10);

              let investigatorRow = 70;

              for (let j = 0; j < investigators.length; j++) {
                doc.text(`${j + 1}. Nama:`, 12, investigatorRow);
                doc.text(investigators[j].InstName, 28, investigatorRow);
                doc.text("No Staf:", 12, (investigatorRow += newLine));
                doc.text(investigators[j].InstStaffID, 28, investigatorRow);
                doc.text(
                  "Service Area / Jabatan: ",
                  12,
                  (investigatorRow += newLine)
                );
                doc.text(investigators[j].InstDept, 50, investigatorRow);

                investigatorRow += newSpacing;
              }

              // ######################################################### BAHAGIAN B1 ######################################################### //
              doc.addPage();
              doc.rect(10, 20, 195, 263);
              doc.setDrawColor(0);
              doc.setFillColor(211, 211, 211);
              doc.rect(10, 20, 195, 11, "FD");
              doc.setFontType("bold");
              doc.setFontSize(10);
              doc.text("B. PENGUMPULAN MAKLUMAT", 12, 25);

              doc.setFontType("bold");
              doc.setFontSize(10);
              doc.text("B1 Maklumat Individu Terlibat Dalam Kejadian", 12, 40);

              let currentRow = 45;

              for (let i = 0; i < personInvolve.length; i++) {
                doc.setFontType("normal");
                doc.setFontSize(10);

                if (i == 0) {
                  doc.text("Nama", 12, currentRow);
                  doc.text(":", 52, currentRow);
                  doc.text(personInvolve[i].VicName, 57, currentRow);
                } else {
                  doc.text("Nama", 12, (currentRow += newSpacing));
                  doc.text(":", 52, currentRow);
                  doc.text(personInvolve[i].VicName, 57, currentRow);
                }

                doc.text("No KP/ Passport", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(personInvolve[i].VicKp, 57, currentRow);

                doc.text("No Pekerja", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(personInvolve[i].VicStaffID, 57, currentRow);

                doc.text("Umur ", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(personInvolve[i].VicAge, 57, currentRow);

                doc.text("No Telefon", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(personInvolve[i].VicTelNo, 57, currentRow);

                doc.text("Kawasan Kerja", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(personInvolve[i].VicWorkArea, 57, currentRow);

                doc.text("Skop Kerja", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(personInvolve[i].VicWorkScope, 57, currentRow);

                doc.text("Penyelia", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(personInvolve[i].VicSupervisor, 57, currentRow);

                doc.text("Tahun Mula Berkhidmat", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(personInvolve[i].VicStartDate, 57, currentRow);

                doc.text("Alamat Rumah", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(personInvolve[i].VicHomeAddr, 57, currentRow);

                // CHECK FIRST IF MORE THAN MAX HEIGHT
                if ((i + 1) % 4 == 0) {
                  currentRow = 15;
                  doc.addPage();
                  doc.rect(10, 20, 195, 263);
                }
              }

              // ######################################################### BAHAGIAN B2 ######################################################### //
              if (vehicleInvolve.length != 0) {
                if (currentRow + newSpacing > 283) {
                  currentRow = 25;
                  doc.addPage();
                  doc.rect(10, 20, 195, 263);

                  // BAHAGIAN B2
                  doc.setFontType("bold");
                  doc.setFontSize(10);
                  doc.text(
                    "B2 Maklumat Kenderaan Yang Terlibat (jika berkaitan)",
                    12,
                    currentRow
                  );
                } else {
                  // BAHAGIAN B2
                  doc.setFontType("bold");
                  doc.setFontSize(10);
                  doc.text(
                    "B2 Maklumat Kenderaan Yang Terlibat (jika berkaitan)",
                    12,
                    (currentRow += newSpacing)
                  );
                }

                doc.setFontType("normal");
                doc.setFontSize(10);

                for (let i = 0; i < vehicleInvolve.length; i++) {
                  // CHECK FIRST IF MORE THAN MAX HEIGHT
                  if (currentRow + 15 + newSpacing > 283) {
                    currentRow = 15;
                    doc.addPage();
                    doc.rect(10, 20, 195, 263);
                  }

                  doc.text(
                    "No Pendaftaran Kenderaan",
                    12,
                    (currentRow += newSpacing)
                  );
                  doc.text(":", 57, currentRow);
                  doc.text(vehicleInvolve[i].VehRegNo, 62, currentRow);
                  doc.text("Jenis Kenderaan", 12, (currentRow += newLine));
                  doc.text(":", 57, currentRow);
                  doc.text(vehicleInvolve[i].VehType, 62, currentRow);
                  doc.text(
                    "Tarikh Tamat Cukai Jalan",
                    12,
                    (currentRow += newLine)
                  );
                  doc.text(":", 57, currentRow);
                  doc.text(vehicleInvolve[i].VehRtaxDate, 62, currentRow);
                  doc.text(
                    "Tarikh Tamat PUSPAKOM",
                    12,
                    (currentRow += newLine)
                  );
                  doc.text(":", 57, currentRow);
                  doc.text(vehicleInvolve[i].VehPuspaDate, 62, currentRow);
                }
              }

              // ######################################################### BAHAGIAN B3 ######################################################### //
              if (currentRow + newSpacing + 40 > 283) {
                currentRow = 25;

                // NEW PAGE
                doc.addPage();
                doc.rect(10, 20, 195, 263);
                doc.setFontType("bold");
                doc.setFontSize(10);
                doc.text("B3 Maklumat Kejadian", 12, 25);
                doc.setFontType("normal");
                doc.setFontSize(10);
                doc.text("Tarikh Kejadian", 12, (currentRow += newSpacing));
                doc.text(":", 52, currentRow);
                doc.text(instDetail.InDate, 57, currentRow);

                doc.text("Masa Kejadian", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(instDetail.InTime, 57, currentRow);

                doc.text("Lokasi Kejadian", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(instDetail.LocDetail, 57, currentRow);

                doc.text("Keadaan Cuaca", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(instDetail.WeatherCond, 57, currentRow);

                doc.text("Keadaan Persekitaran", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(instDetail.SurrCond, 57, currentRow);

                doc.text("Kecederaan", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(instDetail.Injury, 57, currentRow);

                doc.text("Kerosakan Harta Benda", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(instDetail.PropDamage, 57, currentRow);

                doc.text("Ringkasan Kejadian", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                let inSummary = doc.splitTextToSize(instDetail.InSummary, 150);
                doc.text(57, currentRow, inSummary);

                // doc.text(inSummary, 57, currentRow);
              } else {
                // BAHAGIAN B3
                doc.setFontType("bold");
                doc.setFontSize(10);
                doc.text(
                  "B3 Maklumat Kejadian",
                  12,
                  (currentRow += newSpacing)
                );
                doc.setFontType("normal");
                doc.setFontSize(10);
                doc.text("Tarikh Kejadian", 12, (currentRow += newSpacing));
                doc.text(":", 52, currentRow);
                doc.text(instDetail.InDate, 57, currentRow);

                doc.text("Masa Kejadian", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(instDetail.InTime, 57, currentRow);

                doc.text("Lokasi Kejadian", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(instDetail.LocDetail, 57, currentRow);

                doc.text("Keadaan Cuaca", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(instDetail.WeatherCond, 57, currentRow);

                doc.text("Keadaan Persekitaran", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(instDetail.SurrCond, 57, currentRow);

                doc.text("Kecederaan", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(instDetail.Injury, 57, currentRow);

                doc.text("Kerosakan Harta Benda", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                doc.text(instDetail.PropDamage, 57, currentRow);

                doc.text("Ringkasan Kejadian", 12, (currentRow += newLine));
                doc.text(":", 52, currentRow);
                let inSummary = doc.splitTextToSize(instDetail.InSummary, 150);
                doc.text(57, currentRow, inSummary);
                // doc.text(instDetail.InSummary, 57, currentRow);
              }

              // ######################################################### BAHAGIAN B4 ######################################################### //
              doc.addPage();
              doc.rect(10, 20, 195, 263);

              doc.setFontType("bold");
              doc.setFontSize(10);
              doc.text("B4 Maklumat Bergambar", 12, 25);
              doc.setFontType("normal");
              doc.setFontSize(9);
              doc.setFontStyle("italic");
              doc.text(
                "(Sekurang-kurangnya gambar lokasi kejadian, kecederaan pekerja atau orang awam, kerosakan harta benda syarikat atau awam)",
                12,
                30
              );

              doc.rect(15, 40, 90, 75);
              doc.rect(110, 40, 90, 75);
              doc.line(15, 90, 105, 90);
              doc.line(110, 90, 200, 90);

              // // newImage.src = "https://cors-anywhere.herokuapp.com/https://alpha.vectolabs.com:9991/images/11290_1587024651.jpg"
              doc.rect(15, 120, 90, 75);
              doc.rect(110, 120, 90, 75);
              doc.line(15, 170, 105, 170);
              doc.line(110, 170, 200, 170);

              doc.rect(15, 200, 90, 75);
              doc.rect(110, 200, 90, 75);
              doc.line(15, 250, 105, 250);
              doc.line(110, 250, 200, 250);

              const imgSpace = 80;
              let imgRow = 43;
              let descRow = 95;

              let newImages = [];

              // for (let j = 0; j < images.length; j++) {

              //   newImages[j] = document.createElement("img");

              //   newImages[j].src =
              //     "https://cors-anywhere.herokuapp.com/" +
              //     process.env.VUE_APP_API_URL +
              //     // "localhost" +
              //     ":9994/images/" +
              //     images[j].ImageFile;
              //   //  require("@/assets/img/No_image.jpg");
              // }

              for (let j = 0; j < images.length; j++) {
                console.log(images[j].ImageFile);

                if (j % 2 == 0) {
                  doc.addImage(
                    await this.getImageB64(images[j].ImageFile),
                    "JPG",
                    20,
                    imgRow,
                    80,
                    45
                  );
                  // doc.addImage(newImages[j], "JPG", 20, imgRow, 80, 45);
                  doc.setFontType("normal");
                  doc.setFontSize(10);
                  let desc = "";
                  if (images[j] != undefined)
                    desc = doc.splitTextToSize(images[j].ImageDesc, 85);
                  doc.text(17, descRow, desc);
                }

                if (j % 2 == 1) {
                  doc.addImage(
                    await this.getImageB64(images[j].ImageFile),
                    "JPG",
                    115,
                    imgRow,
                    80,
                    45
                  );
                  doc.setFontType("normal");
                  doc.setFontSize(10);
                  let desc = "";
                  if (images[i] != undefined)
                    desc = doc.splitTextToSize(images[j].ImageDesc, 85);
                  doc.text(112, descRow, desc);

                  imgRow += imgSpace;
                  descRow += imgSpace;
                }
              }

              doc.line(15, 283, 205, 283);

              // ######################################################### BAHAGIAN C ######################################################### //
              doc.addPage();
              doc.rect(10, 20, 195, 263);
              doc.setDrawColor(0);
              doc.setFillColor(211, 211, 211);
              doc.rect(10, 20, 195, 11, "FD");
              doc.setFontType("bold");
              doc.setFontSize(10);
              doc.text("C. SIASATAN PUNCA KEJADIAN", 12, 25);

              doc.setFontType("bold");
              doc.setFontSize(10);
              doc.text("Nota Penting", 12, 35);
              doc.line(12, 36, 35, 36);

              doc.setFontType("normal");
              doc.setFontSize(9);
              doc.text(
                "1. Siasatan dilakukan merangkumi faktor '4M - Man, Machine, Materials & Method' untuk mengenalpasti punca kejadian.",
                12,
                40
              );
              doc.text(
                "2. Kaedah 'Why-Why' digunakan bagi setiap punca awal yang dikenalpasti untuk mendapatkan punca sebenar kejadian.",
                12,
                45
              );
              doc.text(
                "3. Jika ada faktor yang tidak berkaitan sila tulis 'tidak berkaitan'.",
                12,
                50
              );

              doc.setFontType("bold");
              doc.setFontSize(10);
              doc.text("C1 : Punca Disebabkan Oleh Manusia (Man)", 12, 60);
              doc.rect(12, 63, 190, 45);
              doc.setFontType("normal");
              doc.setFontSize(10);
              let humanDesc = doc.splitTextToSize(causeBy.CauseByHuman, 85);
              doc.text(15, 68, humanDesc);

              doc.setFontType("bold");
              doc.setFontSize(10);
              doc.text("C2 : Punca Disebabkan Oleh Mesin (Machine)", 12, 115);
              doc.rect(12, 118, 190, 45);

              doc.setFontType("normal");
              doc.setFontSize(10);
              let machineDesc = doc.splitTextToSize(causeBy.CauseByMachine, 85);
              doc.text(15, 123, machineDesc);

              doc.setFontType("bold");
              doc.setFontSize(10);
              doc.text(
                "C3 : Punca Disebabkan Oleh Peralatan / Bahan (Material)",
                12,
                170
              );
              doc.rect(12, 173, 190, 45);
              doc.setFontType("normal");
              doc.setFontSize(10);
              let materialDesc = doc.splitTextToSize(
                causeBy.CauseByMaterial,
                85
              );
              doc.text(15, 178, materialDesc);

              doc.setFontType("bold");
              doc.setFontSize(10);
              doc.text(
                "C4 : Punca Disebabkan Oleh Sistem Kerja (Method)",
                12,
                225
              );
              doc.rect(12, 228, 190, 45);
              doc.setFontType("normal");
              doc.setFontSize(10);
              let methodDesc = doc.splitTextToSize(causeBy.CauseByMethod, 85);
              doc.text(15, 233, methodDesc);

              // ######################################################### BAHAGIAN D ######################################################### //
              doc.addPage();
              doc.rect(10, 20, 195, 263);
              doc.setDrawColor(0);
              doc.setFillColor(211, 211, 211);
              doc.rect(10, 20, 195, 16, "FD");
              doc.setFontType("bold");
              doc.setFontSize(10);
              doc.text(
                "D. RANCANGAN TINDAKAN PENCEGAHAN DAN/ATAU TINDAKAN PEMBETULAN.",
                12,
                25
              );
              doc.text(
                "Gunakan 6 langkah kawalan: penghapusan, penggantian, pengasingan, kawalan kejuruteraan, kawalan",
                12,
                30
              );
              doc.text("pentadbiran & PPE.", 12, 34.5);

              doc.setFontType("bold");
              doc.setFontSize(10);
              doc.text("Nota Penting", 12, 40);
              doc.line(12, 41, 35, 41);

              doc.setFontType("normal");
              doc.setFontSize(9);
              doc.text(
                "1. Gunakan 6 langkah kawalan (mengikut hirarki) di dalam merangka rancangan tindakan pencegahan dan/atau tindakan pembetulan.",
                12,
                45
              );
              doc.text(
                "2. Sila masukkan tarikh perlaksanaan/ siap bagi setiap rancangan.",
                12,
                50
              );
              doc.text(
                "3. Jika ada langkah kawalan yang tidak sesuai atau berkaitan sila tulis 'tidak berkaitan'.",
                12,
                55
              );

              doc.setDrawColor(0);
              doc.setFillColor(211, 211, 211);
              doc.rect(10, 60, 195, 9, "FD");
              doc.line(50, 60, 50, 283);
              doc.line(165, 60, 165, 283);

              doc.setFontType("normal");
              doc.setFontSize(10);
              doc.text("Langkah Kawalan", 11, 64);
              doc.text("Rancangan Tindakan Pencegahan / Pembetulan", 51, 64);
              doc.text("Tarikh", 179, 64);
              doc.text("Perlaksanaan/ Siap", 170, 68);
              doc.line(10, 100, 205, 100);
              doc.line(10, 137, 205, 137);
              doc.line(10, 174, 205, 174);
              doc.line(10, 211, 205, 211);
              doc.line(10, 248, 205, 248);

              doc.text("Penghapusan Punca", 12, 74);
              doc.text("Kemalangan/ Hazad", 12, 79);
              doc.text("(Elimination)", 12, 84);
              let penghapusan = doc.splitTextToSize(
                instMethod[0].StepDetail,
                108
              );
              penghapusan[0] == "NONE"
                ? doc.text(52, 74, "tidak berkaitan")
                : doc.text(52, 74, penghapusan);
              doc.text(instMethod[0].DateExecComp, 175, 74);

              doc.text("Penggantian Punca", 12, 104);
              doc.text("Kemalangan/ Hazad", 12, 109);
              doc.text("(Substitution)", 12, 114);
              let penggantian = doc.splitTextToSize(
                instMethod[1].StepDetail,
                108
              );
              penggantian[0] == "NONE"
                ? doc.text(52, 105, "tidak berkaitan")
                : doc.text(52, 105, penggantian);
              doc.text(instMethod[1].DateExecComp, 175, 105);

              doc.text("Pengasingan Punca", 12, 141);
              doc.text("Kemalangan/ Hazad", 12, 146);
              doc.text("(Isolation)", 12, 151);
              let pengasingan = doc.splitTextToSize(
                instMethod[2].StepDetail,
                108
              );
              pengasingan[0] == "NONE"
                ? doc.text(52, 142, "tidak berkaitan")
                : doc.text(52, 142, pengasingan);
              doc.text(instMethod[2].DateExecComp, 175, 142);

              doc.text("Kawalan Kejuruteraan ", 12, 178);
              doc.text("Bagi Punca ", 12, 183);
              doc.text("Kemalangan/ Hazad", 12, 188);
              doc.text("(Engineering Control)", 12, 193);
              let kejuruteraan = doc.splitTextToSize(
                instMethod[3].StepDetail,
                108
              );
              kejuruteraan[0] == "NONE"
                ? doc.text(52, 179, "tidak berkaitan")
                : doc.text(52, 179, kejuruteraan);
              doc.text(instMethod[3].DateExecComp, 175, 179);

              doc.text("Kawalan Pentadbiran", 12, 215);
              doc.text("Bagi Punca", 12, 220);
              doc.text("Kemalangan/ Hazad", 12, 225);
              doc.text("(Administration Control)", 12, 230);
              let pentadbiran = doc.splitTextToSize(
                instMethod[4].StepDetail,
                108
              );
              pentadbiran[0] == "NONE"
                ? doc.text(52, 216, "tidak berkaitan")
                : doc.text(52, 216, pentadbiran);
              doc.text(instMethod[4].DateExecComp, 175, 216);

              doc.text("Penggunaan PPE", 12, 252);
              doc.text("Untuk Meminimumkan", 12, 257);
              doc.text("Pendedahan Kepada", 12, 262);
              doc.text("Punca Kemalangan/ ", 12, 267);
              doc.text("Hazad", 12, 272);
              doc.text("(PPE)", 12, 277);
              let ppe = doc.splitTextToSize(instMethod[5].StepDetail, 108);
              ppe[0] == "NONE"
                ? doc.text(52, 253, "tidak berkaitan")
                : doc.text(52, 253, ppe);
              doc.text(instMethod[5].DateExecComp, 175, 253);

              // ######################################################### BAHAGIAN E ######################################################### //
              doc.addPage();
              doc.rect(10, 20, 195, 263);
              // BAHAGIAN E
              doc.setDrawColor(0);
              doc.setFillColor(211, 211, 211);
              doc.rect(10, 20, 195, 11, "FD");
              doc.setFontType("bold");
              doc.setFontSize(10);
              doc.text("E. PENGESAHAN", 12, 25);

              if (validation.FurtherAction == 1) {
                doc.setDrawColor(0);
                doc.setFillColor(0, 0, 0);
                doc.rect(114, 35, 13, 8, "FD");
              } else {
                doc.rect(114, 35, 13, 8);
              }

              doc.setFontType("normal");
              doc.setFontSize(10);
              doc.text("untuk tindakan lanjut", 128, 40);

              if (validation.Complete == 1) {
                doc.setDrawColor(0);
                doc.setFillColor(0, 0, 0);
                doc.rect(164, 35, 13, 8, "FD");
              } else {
                doc.rect(164, 35, 13, 8);
              }

              doc.setFontType("normal");
              doc.setFontSize(10);
              doc.text("kes ditutup", 178, 40);

              doc.setFontType("normal");
              doc.setFontSize(10);
              doc.text("Disediakan oleh :", 12, 40);
              doc.text(investigators[0].InstName, 42, 40);
              doc.text("Nama : ", 12, 55);
              doc.text(investigators[0].InstName, 25, 55);
              doc.text("Tarikh: ", 140, 55);
              doc.text("2020-02-22", 152, 55);
              doc.text("Jawatan :", 12, 60);
              doc.text(investigators[0].InstDept, 29, 60);

              doc.line(10, 70, 205, 70);
              doc.text("Catatan oleh COO", 12, 75);
              let catatanCOO = doc.splitTextToSize(validation.NoteCOO, 88);
              doc.text(16, 85, catatanCOO);

              doc.rect(14, 80, 94, 80);

              doc.text("Nama:", 12, 170);
              let nameCOO = doc.splitTextToSize(validation.NameCOO, 78);
              doc.text(24, 170, nameCOO);
              doc.text("Tarikh:", 12, 180);
              doc.text(validation.DateCOO, 24, 180);

              doc.line(108, 70, 108, 283); // MIDDLE LINE

              doc.setFontSize(10);
              doc.text("Catatan oleh CEO", 110, 75);
              let catatanCEO = doc.splitTextToSize(validation.NoteCEO, 88);
              doc.text(114, 85, catatanCEO);

              doc.rect(112, 80, 93, 80);

              doc.text("Nama:", 112, 170);
              let nameCEO = doc.splitTextToSize(validation.NameCEO, 78);
              doc.text(124, 170, nameCEO);
              doc.text("Tarikh:", 112, 180);
              doc.text(validation.DateCEO, 124, 180);

              // ######################################################### BAHAGIAN F ######################################################### //
              doc.addPage();
              doc.rect(10, 20, 195, 263);
              // BAHAGIAN F
              doc.setDrawColor(0);
              doc.setFillColor(211, 211, 211);
              doc.rect(10, 20, 195, 27, "FD");
              doc.setFontType("bold");
              doc.setFontSize(10);
              doc.text("F. SESI SUSULAN", 12, 25);

              doc.text(
                "Maklumat pegawai terlibat didalam sesi susulan",
                12,
                30
              );
              doc.line(12, 31, 94, 31);
              doc.text("Nama:", 12, 35);
              doc.text("Jawatan:", 12, 40);
              doc.text("Tarikh & Masa:", 12, 45);

              doc.setFontType("normal");
              doc.setFontSize(10);

              doc.line(10, 55, 205, 55);
              doc.line(10, 94, 205, 94);
              doc.line(10, 132, 205, 132);
              doc.line(10, 170, 205, 170);
              doc.line(10, 208, 205, 208);
              doc.line(10, 246, 205, 246);

              doc.setFontType("bold");
              doc.setFontSize(9);
              doc.text(
                "Keterangan (seperti rancangan tindakan di item D)",
                12,
                53
              );
              doc.line(90, 47, 90, 283);
              doc.text("Tindakan", 92, 53);
              doc.line(115, 47, 115, 283);
              doc.text("Tarikh", 117, 53);
              doc.line(134, 20, 134, 283);
              doc.text("Catatan", 154, 53);
              doc.line(184, 47, 184, 283);
              doc.text("T/tangan", 188, 53);

              doc.setFontType("bold");
              doc.setFontSize(10);
              doc.text("Pengesahan", 136, 25);

              doc.setFontType("normal");
              doc.setFontSize(9);

              let instRow = 60;

              for (let j = 0; j < instMethod.length; j++) {
                if (j == 0) {
                  let keterangan = doc.splitTextToSize(
                    instMethod[j].StepDetail,
                    75
                  );
                  doc.text(keterangan, 12, instRow);
                } else {
                  let keterangan = doc.splitTextToSize(
                    instMethod[j].StepDetail,
                    75
                  );
                  doc.text(keterangan, 12, instRow);
                }
                instRow += 38;
              }

              if (followUp.length != 0) {
                doc.text(followUp[0].Name, 25, 35);
                doc.text(followUp[0].Designation, 30, 40);
                doc.text(
                  moment(followUp[0].DateTime).format("YYYY-MM-DD hh:mm a"),
                  40,
                  45
                );

                // TINDAKAN
                doc.setFontType("normal");
                doc.setFontSize(9);
                let penghapusanD = doc.splitTextToSize(followUp[0].Action, 20);
                doc.text(penghapusanD, 92, 60);
                let penggantianD = doc.splitTextToSize(followUp[1].Action, 20);
                doc.text(penggantianD, 92, 98);
                let pengasinganD = doc.splitTextToSize(followUp[2].Action, 20);
                doc.text(pengasinganD, 92, 136);
                let kejuruteraanD = doc.splitTextToSize(followUp[3].Action, 20);
                doc.text(kejuruteraanD, 92, 174);
                let pentadbiranD = doc.splitTextToSize(followUp[4].Action, 20);
                doc.text(pentadbiranD, 92, 212);
                let ppeD = doc.splitTextToSize(followUp[5].Action, 20);
                doc.text(ppeD, 92, 250);

                // TARIKH
                doc.text(followUp[0].Date, 116, 60);
                doc.text(followUp[1].Date, 116, 98);
                doc.text(followUp[2].Date, 116, 136);
                doc.text(followUp[3].Date, 116, 174);
                doc.text(followUp[4].Date, 116, 212);
                doc.text(followUp[5].Date, 116, 250);

                // CATATAN
                let note1 = doc.splitTextToSize(followUp[0].Note, 46);
                doc.text(note1, 135, 60);
                let note2 = doc.splitTextToSize(followUp[1].Note, 46);
                doc.text(note2, 135, 98);
                let note3 = doc.splitTextToSize(followUp[2].Note, 46);
                doc.text(note3, 135, 136);
                let note4 = doc.splitTextToSize(followUp[3].Note, 46);
                doc.text(note4, 135, 174);
                let note5 = doc.splitTextToSize(followUp[4].Note, 46);
                doc.text(note5, 135, 212);
                let note6 = doc.splitTextToSize(followUp[5].Note, 46);
                doc.text(note6, 135, 250);
              }
              doc.save(
                `Investigation_${this.multipleSelection[i].ControlCaseNo}.pdf`
              );

              var img2 = image.jkkpImage;

              for (let j = 0; j < jkkpForm.length; j++) {
                if (jkkpForm[j].Jkkp == 7) {
                  var jkkp7 = jsPDF("p", "mm", "a4");
                  // ####################################################################### JKKP 7 ####################################################################### //

                  jkkp7.rect(140, 10, 52, 6);
                  jkkp7.setFontSize(10);
                  jkkp7.setFontType("bold");
                  jkkp7.text("Form No.:SH/FR02/R0", 148, 14);
                  jkkp7.text("JKKP7", 180, 25);

                  jkkp7.addImage(img2, "JPEG", 90, 20, 30, 15);
                  jkkp7.text(
                    "LAPORAN MENGENAI KERACUNAN PEKERJAAN / PENYAKIT PEKERJAAN",
                    40,
                    41
                  );
                  jkkp7.text(
                    "PERATURAN - PERATURAN KESELAMATAN DAN KESIHATAN PEKERJAAN",
                    39,
                    46
                  );
                  jkkp7.text(
                    "(PEMBERITAHUAN MENGENAI KEMALANGAN, KEJADIAN BERBAHAYA,",
                    42,
                    51
                  );
                  jkkp7.text(
                    "KERACUNAN PEKERJAAN DAN PENYAKIT PEKERJAAN) 2004",
                    52,
                    56
                  );

                  jkkp7.text("Bahagian A1", 15, 65);

                  jkkp7.setFontSize(10);
                  jkkp7.setFontType("normal");
                  jkkp7.text("Pemberitahuan - Peraturan 7 (1)", 15, 72);
                  jkkp7.text("Nama", 15, 79);
                  jkkp7.rect(35, 75, 60, 11);
                  let notiName = jkkp7.splitTextToSize(jkkpForm[j].NrName, 57);
                  jkkp7.text(notiName, 36, 79);
                  jkkp7.text("Jawatan", 15, 90);
                  jkkp7.rect(35, 86, 60, 6);
                  jkkp7.text(jkkpForm[j].NrDesignation, 36, 90);
                  jkkp7.text("Nama & Alamat Organisasi", 15, 96);
                  jkkp7.rect(15, 97, 80, 16);
                  let notiCompAddr = jkkp7.splitTextToSize(
                    jkkpForm[j].NrComp + "; " + jkkpForm[j].NrCompAddr,
                    76
                  );
                  jkkp7.text(notiCompAddr, 16, 101);
                  jkkp7.text("No Telefon :", 15, 117);
                  jkkp7.rect(35, 113, 60, 6);
                  jkkp7.text(jkkpForm[j].NrTelNo, 36, 117);

                  jkkp7.text("No. R. O. C", 15, 127);
                  jkkp7.rect(35, 123, 20, 5);
                  jkkp7.text(jkkpForm[j].ROCNo, 36, 127);
                  jkkp7.text("No. Pend.", 56, 123);
                  jkkp7.text("JKKP", 62, 127);
                  jkkp7.text(jkkpForm[j].JKKPRegNo, 74, 127);
                  jkkp7.rect(73, 123, 29, 5);
                  jkkp7.text(
                    "Orang yang boleh dihubungi (Jika lain dari atas)",
                    15,
                    132
                  );
                  jkkp7.rect(15, 133, 80, 10);
                  let otherContact = jkkp7.splitTextToSize(
                    jkkpForm[j].OtherCtInfo,
                    76
                  );
                  jkkp7.text(otherContact, 16, 137);

                  jkkp7.setFontSize(10);
                  jkkp7.setFontType("bold");
                  jkkp7.text("Bahagian B - Orang yang terlibat", 15, 151);

                  jkkp7.setFontSize(10);
                  jkkp7.setFontType("normal");
                  jkkp7.text("Nama", 15, 157);
                  jkkp7.rect(30, 153, 65, 5);
                  jkkp7.text(jkkpForm[j].VicName, 31, 157);

                  jkkp7.text("Tarikh Lahir", 15, 162);
                  jkkp7.rect(35, 158, 60, 5);
                  jkkp7.text(jkkpForm[j].VicDOB, 36, 162);

                  jkkp7.text("No K/P atau Passport", 15, 167);
                  jkkp7.rect(50, 163, 45, 5);
                  jkkp7.text(jkkpForm[j].VicKP, 51, 167);
                  jkkp7.text("Warganegara", 15, 172);
                  jkkp7.rect(37, 168, 27, 5);
                  jkkp7.text(jkkpForm[j].VicNation, 38, 172);
                  jkkp7.text("Jantina", 65, 172);
                  jkkp7.rect(77, 168, 18, 5);
                  jkkp7.text(jkkpForm[j].VicSex, 78, 172);
                  jkkp7.text("Pekerjaan", 15, 177);
                  jkkp7.rect(35, 173, 60, 5);
                  jkkp7.text(jkkpForm[j].VicOccupation, 36, 177);

                  jkkp7.text("Nama & Alamat Organisasi", 15, 182);
                  jkkp7.rect(15, 183, 80, 14);
                  let jkkp7Addr = jkkp7.splitTextToSize(
                    jkkpForm[j].VicComp + "; " + jkkpForm[j].VicCompAddr,
                    76
                  );
                  jkkp7.text(jkkp7Addr, 16, 187);
                  jkkp7.text("Lokasi Kejadian", 15, 201);
                  jkkp7.rect(15, 202, 80, 10);
                  let inAddr = jkkp7.splitTextToSize(
                    jkkpForm[j].InLocation,
                    76
                  );
                  jkkp7.text(inAddr, 16, 206);
                  //////////////////////////////////////////////
                  jkkp7.setFontSize(10);
                  jkkp7.setFontType("bold");
                  jkkp7.text("Bahagian A2", 108, 65);
                  jkkp7.setFontSize(10);
                  jkkp7.setFontType("normal");
                  jkkp7.text(
                    "Pemberitahuan - Peraturan 7 (2) Pengamal",
                    108,
                    70
                  );
                  jkkp7.text("Perubatan Berdaftar", 108, 75);
                  jkkp7.text("Nama", 108, 80);
                  jkkp7.rect(108, 81, 80, 11);
                  let medicName = jkkp7.splitTextToSize(
                    jkkpForm[j].MedicName,
                    76
                  );
                  jkkp7.text(medicName, 109, 85);

                  jkkp7.text("Jawatan", 108, 96);
                  jkkp7.rect(108, 97, 80, 6);
                  jkkp7.text(jkkpForm[j].MedicDesignation, 109, 101);
                  jkkp7.text("Alama Klinik / Hospital", 108, 111);
                  jkkp7.rect(108, 112, 80, 16);
                  let medicAddr = jkkp7.splitTextToSize(
                    jkkpForm[j].MedicCompAddr,
                    76
                  );
                  jkkp7.text(medicAddr, 109, 116);

                  jkkp7.text("No Telefon", 108, 135);
                  jkkp7.rect(108, 136, 80, 6);
                  jkkp7.text(jkkpForm[j].MedicTelNo, 109, 140);

                  jkkp7.line(15, 145, 190, 145);
                  jkkp7.line(15, 146, 190, 146);

                  jkkp7.setFontSize(10);
                  jkkp7.setFontType("bold");
                  jkkp7.text("Bahagian C", 108, 151);

                  jkkp7.setFontSize(10);
                  jkkp7.setFontType("normal");
                  jkkp7.text("Diagnosis / Diagnosis Sementara", 108, 156);
                  jkkp7.rect(108, 157, 80, 11);
                  let diagnosis = jkkp7.splitTextToSize(
                    jkkpForm[j].Diagnosis,
                    76
                  );
                  jkkp7.text(diagnosis, 109, 161);

                  jkkp7.text("Tarikh Diagnosis", 108, 175);
                  jkkp7.rect(108, 176, 80, 6);
                  jkkp7.text(jkkpForm[j].DiagnosisDate, 109, 180);

                  jkkp7.text("Nama & Alamat Doktor yang merawat", 108, 190);
                  jkkp7.rect(108, 196, 80, 16);
                  let medicNameAddr = doc.splitTextToSize(
                    jkkpForm[j].DoctorName + "; " + jkkpForm[j].DoctorAddr,
                    76
                  );
                  jkkp7.text(medicNameAddr, 109, 200);

                  // BAHAGIAN D
                  // if (jkkpForm[j].InDetail.length > 390) {
                  jkkp7.addPage();
                  jkkp7.setFontSize(10);
                  jkkp7.setFontType("bold");
                  jkkp7.text("Bahagian D -", 15, 25);

                  jkkp7.setFontSize(9.6);
                  jkkp7.setFontType("normal");
                  jkkp7.text(
                    "Huraian pekerjaan yang membawa kepada keracunan pekerjaan / penyakit pekerjaan (Sila huraikan sebarang kerja",
                    15,
                    30
                  );
                  jkkp7.text(
                    "yang dibuat oleh yang terlibat yang mungkin telah membawa kepada penyakit. Jika mungkin disebabkan oleh",
                    15,
                    34
                  );
                  jkkp7.text(
                    "pendedahan kepada sebarang agen semasa kerja, contoh kimia yang spesifik - sila nyatakan agen berkenaan).",
                    15,
                    38
                  );
                  jkkp7.rect(15, 41, 174, 180);

                  let bahagianD = doc.splitTextToSize(
                    jkkpForm[j].InDetail,
                    160
                  );
                  console.log(bahagianD);
                  jkkp7.text(bahagianD, 16, 45);
                  jkkp7.rect(15, 252, 54, 16);

                  jkkp7.setFontSize(10);
                  jkkp7.setFontType("normal");
                  jkkp7.text("Tanda Tangan Pemberitahu", 15, 272);
                  jkkp7.text("Tarikh", 15, 277);
                  jkkp7.rect(37, 274, 32, 5);

                  jkkp7.setFontSize(7);
                  jkkp7.setFontType("bold");
                  jkkp7.setFontStyle("italic");
                  jkkp7.text("Penafian", 15, 284);
                  jkkp7.text(
                    "Mengisi borang ini tidak menjadikan pengakuan ke atas sebarang liabiliti oleh orang yang mengisi borang.",
                    15,
                    288
                  );
                  // } else {
                  //   jkkp7.line(15, 214, 190, 214);
                  //   jkkp7.line(15, 215, 190, 215);
                  //   jkkp7.setFontSize(10);
                  //   jkkp7.setFontType("bold");
                  //   jkkp7.text("Bahagian D -", 15, 220);

                  //   jkkp7.setFontSize(9.6);
                  //   jkkp7.setFontType("normal");
                  //   jkkp7.text(
                  //     "Huraian pekerjaan yang membawa kepada keracunan pekerjaan / penyakit pekerjaan (Sila huraikan sebarang kerja",
                  //     15,
                  //     225
                  //   );
                  //   jkkp7.text(
                  //     "yang dibuat oleh yang terlibat yang mungkin telah membawa kepada penyakit. Jika mungkin disebabkan oleh",
                  //     15,
                  //     229
                  //   );
                  //   jkkp7.text(
                  //     "pendedahan kepada sebarang agen semasa kerja, contoh kimia yang spesifik - sila nyatakan agen berkenaan).",
                  //     15,
                  //     233
                  //   );
                  //   jkkp7.rect(15, 234, 174, 16);
                  //   let bahagianD = doc.splitTextToSize(
                  //     jkkpForm[j].InDetail,
                  //     160
                  //   );
                  //   console.log(bahagianD);
                  //   jkkp7.text(bahagianD, 16, 238);
                  //   jkkp7.rect(15, 252, 54, 16);

                  //   jkkp7.setFontSize(10);
                  //   jkkp7.setFontType("normal");
                  //   jkkp7.text("Tanda Tangan Pemberitahu", 15, 272);
                  //   jkkp7.text("Tarikh", 15, 277);
                  //   jkkp7.rect(37, 274, 32, 5);

                  //   jkkp7.setFontSize(7);
                  //   jkkp7.setFontType("bold");
                  //   jkkp7.setFontStyle("italic");
                  //   jkkp7.text("Penafian", 15, 284);
                  //   jkkp7.text(
                  //     "Mengisi borang ini tidak menjadikan pengakuan ke atas sebarang liabiliti oleh orang yang mengisi borang.",
                  //     15,
                  //     288
                  //   );
                  // }

                  jkkp7.save(`jkkp7.pdf`);
                } else if (jkkpForm[j].Jkkp == 6) {
                  var jkkp6 = jsPDF("p", "mm", "a4");
                  // ####################################################################### JKKP 6 ####################################################################### //
                  jkkp6.rect(140, 10, 52, 6);
                  jkkp6.setFontSize(10);
                  jkkp6.setFontType("bold");
                  jkkp6.text("Form No.: SH/FR01/R0", 148, 14);

                  jkkp6.addImage(img2, "JPEG", 90, 20, 30, 15);
                  jkkp6.text(
                    "JKKP 6 - LAPORAN MENGENAI KEMALANGAN/KEJADIAN BERBAHAYA ",
                    40,
                    41
                  );
                  jkkp6.setFontSize(8);
                  jkkp6.setFontType("bold");
                  jkkp6.text(
                    "PERATURAN-PERATURAN KESELAMATAN DAN KESIHATAN PEKERJAAN (PEMBERITAHUAN MENGENAI KEMALANGAN, KEJADIAN",
                    15,
                    46
                  );
                  jkkp6.text(
                    "BERBAHAYA, KERACUNAN PEKERJAAN DAN PENYAKIT PEKERJAAN) 2004",
                    51,
                    51
                  );

                  jkkp6.setFontSize(10);
                  jkkp6.setFontType("bold");
                  jkkp6.text("Bahagian A - Maklumat Pemberitahu", 15, 65);

                  jkkp6.setFontSize(7);
                  jkkp6.setFontType("normal");
                  jkkp6.text(
                    "Pemberitahu - Peraturan 5 (1)&(2) Majikan",
                    15,
                    68
                  );

                  jkkp6.setFontSize(10);
                  jkkp6.setFontType("normal");
                  jkkp6.text("Nama", 15, 75);
                  jkkp6.rect(15, 76, 93, 5);
                  jkkp6.text(jkkpForm[j].NrName, 16, 80);

                  jkkp6.text("Jawatan", 15, 85);
                  jkkp6.rect(15, 86, 93, 5);
                  jkkp6.text(jkkpForm[j].NrDesignation, 16, 90);

                  jkkp6.text("Nama & Alamat Organisasi", 15, 95);
                  jkkp6.rect(15, 96, 93, 15);
                  let nameCompAddr = jkkp6.splitTextToSize(
                    jkkpForm[j].NrComp + "; " + jkkpForm[j].NrCompAddr,
                    90
                  );
                  jkkp6.text(nameCompAddr, 16, 100);

                  jkkp6.text("No.ROC", 15, 120);
                  jkkp6.rect(30, 116, 20, 5);
                  jkkp6.text(jkkpForm[j].ROCNo, 31, 120);

                  jkkp6.text("No.Pend.JKKP", 53, 120);
                  jkkp6.rect(78, 116, 30, 5);
                  jkkp6.text(jkkpForm[j].JKKPRegNo, 79, 120);

                  jkkp6.text(
                    "Orang yang boleh dihubungi (Jika lain dari atas)",
                    15,
                    125
                  );
                  jkkp6.rect(15, 126, 93, 15);
                  let otherCtInfo = jkkp6.splitTextToSize(
                    jkkpForm[j].OtherCtInfo,
                    90
                  );
                  jkkp6.text(otherCtInfo, 16, 130);

                  jkkp6.text("No.Telefon", 15, 145);
                  jkkp6.rect(40, 141, 68, 5);
                  jkkp6.text(jkkpForm[j].NrTelNo, 41, 145);

                  jkkp6.text("Kod Klasifikasi Industri (Jadual 3)", 15, 150);
                  jkkp6.rect(80, 146, 28, 5);
                  jkkp6.text("90002", 89, 150);

                  ///////////////////////////////////////////////////////////////
                  jkkp6.setFontSize(10);
                  jkkp6.setFontType("bold");
                  jkkp6.text("Bahagian B - Orang Yang Terlibat", 112, 65);

                  jkkp6.setFontSize(7);
                  jkkp6.setFontType("normal");
                  jkkp6.text(
                    "(Jika lebih dari seorang, sila gunakan borang berasingan )",
                    112,
                    68
                  );

                  jkkp6.setFontSize(10);
                  jkkp6.setFontType("normal");
                  jkkp6.text("Nama", 112, 75);
                  jkkp6.rect(112, 76, 93, 5);
                  jkkp6.text(jkkpForm[j].VicName, 113, 80);

                  jkkp6.text("Tarikh Lahir", 112, 85);
                  jkkp6.rect(135, 81, 70, 5);
                  jkkp6.text(jkkpForm[j].VicDOB, 136, 85);

                  jkkp6.text("No K/P atau No. Pekerja", 112, 90);
                  jkkp6.rect(155, 86, 50, 5);
                  jkkp6.text(jkkpForm[j].VicKP, 156, 90);

                  jkkp6.text("Warganegara", 112, 95);
                  jkkp6.rect(135, 91, 35, 5);
                  jkkp6.text(jkkpForm[j].VicNation, 136, 95);

                  jkkp6.text("Jantina", 171, 95);
                  jkkp6.rect(183, 91, 22, 5);
                  jkkp6.text(jkkpForm[j].VicSex, 184, 95);

                  jkkp6.text("Pekerjaan", 112, 100);
                  jkkp6.rect(135, 96, 70, 5);
                  jkkp6.text(jkkpForm[j].VicOccupation, 136, 100);

                  jkkp6.text("Nama & Alamat Organisasi", 112, 105);
                  jkkp6.rect(112, 106, 93, 15);
                  let vicCompAddr = jkkp6.splitTextToSize(
                    jkkpForm[j].VicComp + "; " + jkkpForm[j].VicCompAddr,
                    90
                  );
                  jkkp6.text(vicCompAddr, 113, 110);

                  jkkp6.text("Tempat Kejadian", 112, 125);
                  jkkp6.rect(112, 126, 93, 15);
                  let inLocation = jkkp6.splitTextToSize(
                    jkkpForm[j].InLocation,
                    90
                  );
                  jkkp6.text(inLocation, 113, 130);

                  jkkp6.text("Tarikh dan Masa Kejadian", 112, 145);
                  jkkp6.rect(165, 141, 40, 5);
                  jkkp6.text(
                    moment(jkkpForm[j].InTimestamp).format(
                      "YYYY-DD-MM hh:mm a"
                    ),
                    166,
                    145
                  );

                  jkkp6.text("Tarikh Mula Lapor kepada JKKP", 112, 150);
                  jkkp6.rect(165, 146, 40, 5);
                  jkkp6.text(jkkpForm[j].ReportDateToJKKP, 166, 150);

                  jkkp6.line(15, 155, 205, 155);
                  jkkp6.line(15, 156, 205, 156);

                  ///////////////////////////////////////////////////////////////
                  jkkp6.setFontSize(10);
                  jkkp6.setFontType("bold");
                  jkkp6.text(
                    "Bahagian C - Huraian kemalangan atau kejadian berbahaya",
                    15,
                    165
                  );

                  jkkp6.setFontSize(10);
                  jkkp6.setFontType("normal");
                  jkkp6.text(
                    "Sila huraikan apa yang berlaku sebelum, semasa dan selepas kejadian.",
                    15,
                    170
                  );
                  jkkp6.rect(15, 172, 190, 60);
                  let inDetail = jkkp6.splitTextToSize(
                    jkkpForm[j].InDetail,
                    186
                  );
                  jkkp6.text(inDetail, 16, 177);

                  jkkp6.rect(15, 236, 60, 15);
                  jkkp6.text("Tanda Tangan Pemberitahu", 15, 255);

                  jkkp6.text("Tarikh", 15, 260);
                  jkkp6.rect(30, 256, 46, 5);

                  jkkp6.setFontSize(10);
                  jkkp6.setFontType("bold");
                  jkkp6.text("Penafian", 15, 270);

                  jkkp6.setFontSize(8);
                  jkkp6.setFontType("normal");
                  jkkp6.setFontStyle("italic");
                  jkkp6.text(
                    "Mengisi borang ini tidak menjadikan pengakuan ke atas sebarang lialibiliti oleh orang yang mengisi borang.",
                    15,
                    274
                  );

                  jkkp6.save(`jkkp6.pdf`);
                }
              }
            }
          });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getInstReport() {
      this.$http.get(":9994/api/v1/report/list").then((res) => {
        if (!res.error) {
          for (let i = 0; i < res.message.length; i++) {
            this.tableData.push(res.message[i]);
          }
        }
      });
    },
  },
  created() {
    this.getInstReport();
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["ControlCaseNo"],
      threshold: 0.3,
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>

<style lang="scss" scoped>
.inline {
  margin-top: 1.5%;
  margin-bottom: 1%;
}
hr {
  margin-top: 0%;
}
.style-date {
  margin-bottom: 1%;
}
.style-select {
  padding-top: 1%;
}
</style>
